import { unsafeCSS } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { html } from 'lit/static-html.js'

import { DdsElement } from '../../internal/dds-hu-element'
import styles from './table-cell.scss?inline'

/**
 * Table cell component.
 * @element dap-ds-table-cell
 * @title - Table cell
 * @group table
 *
 * @slot - The default slot.
 *
 * @csspart base - The main cell container.
 *
 * @cssproperty --dds-table-cell-padding-block - Padding for the top and bottom of the cell. (default: var(--dds-spacing-200))
 * @cssproperty --dds-table-cell-padding-inline-start - Padding for the start (left in LTR) of the cell. (default: var(--dds-spacing-500))
 * @cssproperty --dds-table-cell-padding-inline-end - Padding for the end (right in LTR) of the cell. (default: var(--dds-spacing-500))
 * @cssproperty --dds-table-cell-border-width - Width of the cell's bottom border. (default: var(--dds-border-width-base))
 * @cssproperty --dds-table-cell-border-color - Color of the cell's bottom border. (default: var(--dds-border-neutral-subtle))
 * @cssproperty --dds-table-cell-text-color - Text color of the cell. (default: var(--dds-text-neutral-base))
 * @cssproperty --dds-table-cell-line-height - Line height of the cell text. (default: 1.5)
 * @cssproperty --dds-table-cell-text-align - Text alignment in the cell. (default: left)
 */
@customElement('dap-ds-table-cell')
export default class DapDSTableCell extends DdsElement {
  static readonly styles = unsafeCSS(styles)

  /**If the cell is the last one.*/
  @property({ type: Boolean, reflect: true }) last: boolean
  /** The html role of the cell */
  @property({ reflect: true })
  public role = 'cell'

  render() {
    return html` <slot></slot> `
  }
}
